// The server answers with one of these when the caller's org blocks access; it also renders
// the matching blocked page on the next navigation, so a reload is the whole remedy.
const ACCESS_BLOCKED_HEADERS = ["X-Encryption-Access-Disabled", "X-IP-Not-Allowed"];

// A page Django still serves can keep getting blocked API responses: the blocked page itself, a
// public 360 rater page, or any page while coach_api's 60s allowlist cache catches up with
// Django's. Reloading those would loop, so reload once per window and then let the error show.
const RELOAD_WINDOW_MS = 60_000;
const LAST_RELOAD_KEY = "accessBlockedReloadAt";

function claimReload(): boolean {
    try {
        const now = Date.now();
        if (now - Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0) < RELOAD_WINDOW_MS) {
            return false;
        }
        sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
        return true;
    } catch {
        return false;
    }
}

export function isAccessBlocked(response: Response | null | undefined): boolean {
    return ACCESS_BLOCKED_HEADERS.some((header) => response?.headers?.get(header) === "1");
}

export function reloadWhenAccessBlocked(response: Response | null | undefined): void {
    if (isAccessBlocked(response) && claimReload()) {
        globalThis.location.reload();
    }
}
